import React, { useState } from 'react';
import './EarlyAccessForm.css';

const EarlyAccessForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    location: '',
    email: '',
    text: ''
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({ 
      ...formData, 
      [e.target.name]: e.target.value 
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (formData.name && formData.location && formData.email && formData.text) {
      fetch('https://sheetdb.io/api/v1/kc7j83iekmkcq', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          data: {
            ...formData,
            date: new Date().toLocaleString(),
          }
        })
      })
      .then((res) => res.json())
      .then(() => {
        setSubmitted(true);
        setFormData({ name: '', location: '', email: '', text: '' });
      })
      .catch(err => console.error('Submit Error', err));
    }
  };

  return (
    <form onSubmit={handleSubmit} className="early-access-form">
      {!submitted ? (
        <>
          <div className="input-group">
            <input
              type="text"
              className="form-control"
              name="name"
              placeholder="Enter Your Name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>
          <div className="input-group">
            <input
              type="text"
              className="form-control"
              name="location"
              placeholder="Enter Your Location"
              value={formData.location}
              onChange={handleChange}
              required
            />
          </div>
          <div className="input-group">
            <input
              type="email"
              className="form-control"
              name="email"
              placeholder="Enter Your Email"
              value={formData.email}
              onChange={handleChange}
              required
            />
    
          </div>
          <div className="input-group">
            <input
              type="text"
              className="form-control"
              name="text"
              placeholder="Enter Your Feedback or Suggestions"
              value={formData.text}
              onChange={handleChange}
              required
            />
           
          </div>
          <button type="submit" className="btn "> Suggest Now, Try First</button>
        </>
      ) : (
        <div className="thank-you-message">Thank you! You're on the list. 🎉</div>
      )}
    </form>
  );
};

export default EarlyAccessForm;
